import { useState, useRef, FunctionComponent } from 'react';
import classnames from 'classnames';

// components'
import Post from '@Components/UI/Post';
import Anchor from '@Components/Utils/Anchor';
import Slider, { SliderAnchor } from '@Components/Utils/Slider';

// styles
import styles from './Banner.module.scss';

interface BannerProps {
    slide?: Array<any>;
    className?: string;
    highlight?: Array<any>;
}

const Banner: FunctionComponent<BannerProps> = ({ slide, highlight, className }) => {
    const slideRef = useRef<any>();
    const wrapperClassName = classnames([styles.wrapper, className]);

    const [currentSlide, setCurrentSlide] = useState<number>(0);

    const renderDot = () => {
        const dot = [];
        [...Array(slide.length)].forEach((_item, index) => {
            dot.push(<span key={`dot-item-${index}`} className={classnames([styles.dot, { [styles.dot_active]: currentSlide === index }])} onClick={() => slideRef.current.slickGoTo(index)} />);
        });

        return <div className={styles.dots}>{dot}</div>;
    };

    const renderSlideItem = () => {
        return slide.map((slideItem, index) => (
            <SliderAnchor key={`slide-item-${slideItem.id}-${index}`} href={`/bai-viet/${slideItem?.post?.id}`} className={styles.anchor}>
                <Post
                    fullBanner
                    isShowBadge
                    imageWidth={860}
                    image={slideItem.image}
                    infoClassName={styles.info}
                    imageClassName={styles.image}
                    category={slideItem.category}
                    titleClassName={styles.title}
                    title={slideItem?.post?.title}
                    className={styles.banner_slider}
                    imageWrapperClassName={styles.image_wrapper}
                />
            </SliderAnchor>
        ));
    };

    const renderHighlightItem = () => {
        return highlight.map((slideItem, index) => (
            <Anchor key={`highlight-item-${slideItem.id}-${index}`} href={`/bai-viet/${slideItem?.post?.id}`} className={styles.banner}>
                <Post
                    fullBanner
                    isShowBadge
                    imageWidth={300}
                    image={slideItem.image}
                    imageClassName={styles.image}
                    category={slideItem.category}
                    title={slideItem?.post?.title}
                    imageWrapperClassName={styles.image_wrapper}
                />
            </Anchor>
        ));
    };

    const sliderSettings = {
        speed: 500,
        arrows: false,
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1,
        className: 'center',
        autoplaySpeed: 3000,
        centerPadding: '0px',
        beforeChange: (_currentSlide: number, nextSlide: number) => setCurrentSlide(nextSlide),
    };

    return (
        <div className={wrapperClassName}>
            <div className={styles.slider_wrapper}>
                <Slider ref={slideRef} {...sliderSettings} className={styles.slider}>
                    {renderSlideItem()}
                </Slider>
                {renderDot()}
            </div>

            <div className={styles.right_banner_wrapper}>{renderHighlightItem()}</div>
        </div>
    );
};

Banner.defaultProps = {
    slide: [],
    highlight: [],
    className: '',
};

export default Banner;
